export default __webpack_public_path__ + "static/media/Calendar.a9e4b392.svg";